import "./index.scss";
import {
  BrandCashAmounts,
  BrandCashBuyNow,
  BrandCashHeader
} from "components/UI/molecules";
import { useState } from "react";

export const BrandCash = ({ instantConfig, ...brandDetails }) => {
  const greaterValue = Math.max(...instantConfig.denominations);

  const [selected, setSelected] = useState(greaterValue);
  const [inputValue, setInputValue] = useState("");

  const amountInCents = selected === "input" ? inputValue * 100 : selected;

  return (
    <div className="brand-cash">
      <BrandCashHeader {...brandDetails} />
      <div className="brand-cash-container">
        <BrandCashAmounts
          selected={selected}
          setSelected={setSelected}
          inputValue={inputValue}
          setInputValue={setInputValue}
          {...instantConfig}
        />
        <BrandCashBuyNow
          selected={selected}
          amount={amountInCents}
          {...instantConfig}
          {...brandDetails}
        />
      </div>
    </div>
  );
};
